import React, { useEffect, useState } from 'react';
import { Alert, Container } from 'reactstrap';

import agent from '../../agent';

import LoadingSpinner from '../../components/common/LoadingSpinner';
import Job from './job';
import { JobViewType, PartnerJobViewType } from '../../types/services-api';

const JobPost = (props: { jobId: number | string }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [fetchedJobData, setFetchedJobData] = useState<
    JobViewType | PartnerJobViewType | null
  >(null);
  useEffect(() => {
    //console.log('jobId is ' + props.jobId);
    if (props.jobId) {
      fetchJob({ jobId: props.jobId });
    }
  }, [props.jobId]);

  function fetchJob(props: { jobId: number | string }) {
    //console.log('loading dynamic job ' + jobId);

    agent.Jobs.getPublic({ jobId: props.jobId })
      .then((res) => {
        const internalJobs = res.data.premiumJobs.filter(
          (job) => Number(job.jobId) === Number(props.jobId)
        );
        if (internalJobs.length > 0) {
          setFetchedJobData({ ...internalJobs[0] });
        } else {
          const partnerJobs = res.data.partnerJobs.filter(
            (job) => job.jobKey === props.jobId
          );
          if (partnerJobs.length > 0) {
            setFetchedJobData({ ...partnerJobs[0] });
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        if (err.response?.status === 404) {
          setErrorMessage('This job posting is no longer available');
        } else {
          setErrorMessage(err.message);
        }
        setIsLoading(false);
      });
  }

  if (isLoading) {
    return (
      <>
        <Container>
          <div className="d-flex align-items-center justify-content-center py-3">
            <LoadingSpinner />
          </div>
        </Container>
      </>
    );
  }

  if (!!errorMessage) {
    return (
      <>
        <Container className="py-3">
          <Alert isOpen={!!errorMessage} color="danger">
            {errorMessage}
          </Alert>
        </Container>
      </>
    );
  }

  if (fetchedJobData) {
    return <Job job={{ ...fetchedJobData }} isDynamic={true} />;
  }

  return null;
};

export default JobPost;
